<table class="table table-hover animate__animated animate__zoomIn">
  <thead>
    <tr>
      <th>#</th>
      <th>Bandera</th>
      <th>Nombre</th>
      <th>Poblacion</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let pais of paises; let indice = index">
      <td>{{ indice + 1 }}</td>
      <td>
        <img src="{{ pais.flag }}" alt="" class="small-flag" />
      </td>
      <td>{{ pais.capital }}, {{ pais.name }}</td>
      <td>{{ pais.population | number }}</td>
      <td>
        <a [routerLink]="['/pais', pais.alpha2Code]" class="nav-link"
          >ver más...</a
        >
      </td>
    </tr>
  </tbody>
</table>
